import React, { useEffect, useRef } from 'react';
import { email, srConfig } from '@config';
import styled from 'styled-components';
import sr from '@utils/sr';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      background: transparent;
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);

  useEffect(() => {
    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'C#',
    '.Net MVC/Core',
    'Azure',
    'SQL Server',
    'MySQL',
    'JavaScript (ES6+)',
    'React',
    'Vue',
    'Node.js',
    'Angular',
  ];
  const expertise = [
    'Software Development & Maintenance services',
    'Payment Method Integration (Including Recurring Payment/Vaulting)',
    'API Integration Social media (Facebook, LinkedIn, Twitter), Google APIs, Google Maps',
    'ASP.NET website performance optimization',
    'The Second Payments Services Directive (PSD2), Strong Customer Authentication (SCA), 3-D Secure (3DS) Expert',
    'ERP Software development and maintenance',
    'CI/CD Integration',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hello! My name is <a href={`mailto:${email}`}>Rohit Patel</a>, and I'm a Full Stack
              Developer working remotely! I've spent the last 7+ years as a professional web
              developer where I specialize in design, deployment, and integration of enterprise
              information management applications.
            </p>
          </div>

          <div>
            <br />
            <p>My expertise includes:</p>
            <ul
              className="skills-list"
              style={{ 'grid-template-columns': 'unset', marginTop: '10px' }}>
              {expertise && expertise.map((skill, i) => <li key={i}>{skill}</li>)}
            </ul>
          </div>

          <div>
            <br />
            <p>Here are a few technologies I've been working with recently:</p>
          </div>

          <ul className="skills-list" style={{ marginTop: '10px' }}>
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <img alt="Rohit Patel" src="/static/rohit-patel.jpeg" className="img" />
            {/* <Img fluid={data.avatar.childImageSharp.fluid} alt="Avatar" className="img" /> */}
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
